// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"3e78dec4","252":"096a9204","403":"d084c626"}[chunkId] + ".chunk.css";
};